export default __webpack_public_path__ + "447d920b15edad8719643f23ca62338d.jpeg";